; (function () {
    var

        _$wrapper = null,

        //set to true when a popup is open, can't open another
        _popup_open = false,

        _current_response_id = null,


        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-chat-session-advanced');
            if (_$wrapper.length > 0) {

                setupAccordions();

                setupDisabledOnLoad();

                delta.utility.setupDatePicker(_$wrapper);

                setupChangeSource();

                setupReports();

                setupSendMessageBtn();

                setupEditLinks();

                setupInitiateChatBtn();

                setupChatPrompts();

                setupFormatPrompts();

                setupSendMessage();

                setupCopyResponse();


                setupChatScroll();

                showHideSelectReports();

                setupViewReports();

                setupDeleteReports();

                setupExcelCopy();

                setupRenameSession();

                if (_$wrapper.find('.report-loader-spinner').length > 0) {
                    startReportTimer();
                }

            }
        },

        setupRenameSession = function () {      
            _$wrapper.on('click', '#lnkSessionName', function () {

                if (!_popup_open) {
                    _popup_open = true;

                    var $a = $(this);
                    var sessionID = $a.attr('data-session-id');

                    delta.ajax.get(
                        '/ChatSession/Rename?sessionID=' + sessionID,
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Session Name',
                                content: html,
                                cssClass: 'chat-session-name-popup',
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {
                                    $('.chat-session-name-popup .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input').each(function () {
                                        var $elem = $(this);
                                        formData.append($elem.attr('name'), $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/ChatSession/Rename',
                                        formData,
                                        function (result) {
                                            if (result.isValid) {
                                                location.reload();
                                            } else {
                                                //update popup
                                                $('.chat-session-name-popup .modal-footer .fa-spinner').remove();
                                                $('.chat-session-name-popup .modal-footer button[data-btn-type="ok"]').remove();
                                                let e = $popup.find('.modal-body');
                                                e.addClass('text-danger');
                                                e.html(result.popupHtml);
                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );

                                    return false;
                                }
                            });

                        }
                    );
                }

                return false;
            });
        },
        // enable/disable accordion expand based on completion of previous section
        setupAccordions = function () {
           
            var { responseCount, reportCount, contextCompletedCount, orgDetailsCount } = getSetupData();
            // setup page load
            if (responseCount > 0) {
                $('#btnChatDiv').trigger('click');
            }
            else if (reportCount > 0 && contextCompletedCount > 0) {
                $('#btnContextDiv').trigger('click');
            }
            else if (reportCount > 0 && orgDetailsCount == 0) {
                $('#btnOrgDetailsDiv').trigger('click');
            }

            // setup accordion click
            $('.accordion-button').on('click', fromInitiate = false, function () {

                var currID = $(this).attr('id');
                if (currID == 'btnDataDiv') {
                    return false;
                }

                // get counts and set defaults
                ({ reportCount, responseCount, contextCompleted } = getSetupData());
                var condition = true;
                var message = "";
                var goToDivID = '#collapseData';
                var $rptsSelect = $('#reports-div');
                var loadingRpts = $rptsSelect.find('.report-loader-spinner').length != 0;
                switch (currID) {
                    case "btnOrgDetailsDiv":
                        condition = reportCount > 0;
                        message = "Please add reports for analysis";
                        break;
                    case "btnContextDiv":
                        condition = reportCount > 0 && !loadingRpts;
                        message = loadingRpts ? "Please wait until reports have finished loading." : "Please add reports for analysis.";
                        break;
                    case "btnChatDiv":
                        condition = reportCount > 0 && responseCount > 0 && !loadingRpts;
                        var text = "";
                        if (reportCount == 0) {
                            text = "Please add reports for analysis."
                        }
                        else if(loadingRpts) {
                            text = "Please wait until reports have finished loading."
                        }
                        else {
                            text = "Please initiate the chat in the 'Start a Discussion' section."
                        }
                        message = `<span class=italic>${text}</span>`;
                        if (reportCount > 0 && !loadingRpts) {
                            goToDivID = "#collapseContextConfiguration"
                        }
                }
                if (!condition) {
                    showWarningPopup(message, goToDivID);
                }
            });

            return false;

        },


        getSetupData = function () {
            var responseCount = $('#ResponseCount').val();
            var reportCount = $('#ReportCount').val();

            // get contextCompleted and count
            var organizationDetails = $('#hdnOrganizationDetails').val() === 'True';
            var currentUrgentInfo = $('#hdnCurrentUrgentInfo').val() === 'True';
            var contextRole = $('#hdnContextRole').val() === 'True';

            //todo: confirm this is needed. MJC
            var sessionName = $('#SessionName').val();
            var contextTask = $('#hdnContextTask').val() === 'True';
            var contextAudience = $('#hdnContextAudience').val() === 'True';
            var orgDetailsCount = organizationDetails ? 1 : 0;
            var contextCompleted = contextRole && contextTask;
            var contextCompletedCount = [currentUrgentInfo, contextRole, contextTask, contextAudience].filter(Boolean).length;
            return { responseCount, reportCount, orgDetailsCount, contextCompleted, contextCompletedCount, sessionName };
        };


        showWarningPopup = function (message, goToDivID) {
            delta.popup.open({
                type: 'alert',
                title: '<i class="fa-solid fa-circle-exclamation"></i> Must Start Discussion',
                content: `<span>${message}</span>`,
                okCallback: function ($popup) {
                    $popup.on("hidden.bs.modal", function () {
                        $(goToDivID).collapse('show');
                    });
                },
            });
        }




        // disable relevant fields on load if responses/reports present
    setupDisabledOnLoad = function () {
        var responses = $('#ResponseCount').val();
        var reports = $('#ReportCount').val();
        var disabled = responses > 0 || reports > 0;

        $('#AnalysisEndDate').prop('disabled', disabled);
        $('#ReportSource').prop('disabled', disabled);
        if ($('#ReportSource').val() != "") {
            $('#reports-div').show();
        }

        // hide context edit links if responses
        if (responses > 0) {
            $('.lnk-edit').addClass('disable');
        } else {
            $('.lnk-edit').removeClass('disable');
        }
    },




        //
        // show report source div based on report source selected
        //
        setupChangeSource = function () {
            _$wrapper.on('change', '#ReportSource', function () {

                var reportSource = $(this).val();

                // show/hide report select and list
                var $rptsSelect = $('#reports-div');
                if (reportSource != "") {
                    $rptsSelect.show();
                }
                else {
                    $rptsSelect.hide();
                }
                showHideSelectReports();

                // show/hide reporting date
                var $rptDate = $('#reporting-date');
                if (reportSource == "QuickBooksOnline") {
                    $rptDate.show();
                }
                else {
                    $rptDate.hide();
                }

                showHideSelectReports();


            })
        },

        //
        // show/hide the select reports link
        //
        showHideSelectReports = function () {
            var reportSource = $('#ReportSource').val();
            var $rptsSelect = $('#reports-div');
            var $lnkSelect = $('#lnk-select-reports');
            var $lnkLoad = $('#lnk-load-reports');
            var $selLnksDiv = $('#select-reports');
            if ($rptsSelect.find('.report-loader-spinner').length == 0) {
                $selLnksDiv.show();
            }
            else {
                $selLnksDiv.hide();
            }
            if (reportSource != "" && /*$rptsSelect.is(':visible') && */  reportSource != "CopyFromExcel" && $rptsSelect.find('.report-loader-spinner').length == 0) {
                $lnkSelect.show();
                $lnkLoad.hide();
            } else if (reportSource == "CopyFromExcel") {
                $lnkSelect.hide();
                $lnkLoad.show();
            }

        },


        setupReports = function () {
        _$wrapper.on('click', '.lnkReports', function () {
            if (!_popup_open) {
                _popup_open = true;

                var reportSource = $("#ReportSource").val();
                var title = "";

                    switch (reportSource) {
                        case 'ReportsYPTC':
                            title = 'ReportsYPTC&#8482;';
                            break;
                        case 'QuickBooksOnline':
                            title = 'QuickBooks&#174; Online';
                            break;
                    }
                    delta.ajax.get(
                        '/ChatSession/Reports?reportSource=' + reportSource,
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: title,
                                content: html,
                                css: 'modal-lg',
                                afterOpen: async function () {
                                    _popup_open = false;

                                    var reportIds = $('.report-id').map(function () {
                                        return $(this).val();
                                    }).get();

                                    for (const rptID of reportIds) {

                                        var $checkbox = $("input[type='checkbox'][value='" + rptID + "']");
                                        // var $label = $checkbox.next('label');
                                        var $label = $checkbox.closest('label');

                                        var isValid = await validateReport(rptID);

                                        // update list
                                        $label.find("i.fa-spinner").remove();
                                        if (isValid) {
                                            $checkbox.prop('disabled', false);
                                            $label.removeClass("muted");
                                        }
                                        else {
                                            $label.append('<span class="italic"> (incomplete, please review)<span>');
                                        }

                                    }

                                    $('#validating').text("All reports checked.");



                                },
                                okCallback: function ($popup) {

                                    $('#autoPopup_1 .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3 mr10"></i>');
                                    // remove any report label spinners if ok clicked before validation complete on all reports
                                    $popup.find('label:has(i.fa-spinner)').each(function () {
                                        $(this).find('i.fa-spinner').remove();
                                    });

                                    var formData = new FormData();

                                    var chatID = $popup.find($('#ChatID')).val();
                                    formData.append('ChatID', chatID);

                                    // save chat details in event user exits before sending chat
                                    var sessionName = _$wrapper.find('#SessionName').val();

                                    assertString(sessionName, "Session Name is not valid");

                                    formData.append('SessionName', sessionName);
                                    var reportSource = _$wrapper.find('#ReportSource').val();
                                    formData.append('ReportSource', reportSource);
                                    var analysisEndDate = _$wrapper.find('#AnalysisEndDate').val();
                                    formData.append('AnalysisEndDate', analysisEndDate);

                                    $popup.find('.modal-body').find('input:checkbox').each(function () {
                                        var $elem = $(this);
                                        if ($elem.is(':checked')) {
                                            if ($elem.hasClass('QBO')) {
                                                formData.append('QBOReports', $elem.attr('name'));
                                            }
                                            else {
                                                formData.append('SystemReportIDs', $elem.val());
                                            }
                                        }
                                    });

                                    delta.ajax.postFormData(
                                        '/ChatSession/Reports',
                                        formData,
                                        function (result) {
                                            // update UI
                                            var disabled = result.count > 0;
                                            $('#reports-list').html(result.html);
                                            $('#AnalysisEndDate').prop('disabled', disabled);
                                            $('#ReportSource').prop('disabled', disabled)

                                            // update ReportCount (used for validation)
                                            updateReportCount(result.count, true);

                                            // update ReportListTitles
                                            $('#ReportListTitles').val(result.titles)
                                            $('#rptListTitles').text(result.titles)

                                            // update LastUpdate
                                            $('#lastUpdated').text(result.timestamp);

                                            delta.popup.close($popup);

                                            showHideSelectReports();
                                            if (result.loadingQBOReportData) {
                                                startReportTimer();
                                            }
                                        }
                                    );

                                    return false;
                                }
                            });
                        }
                    )
                }
            })

        },


        validateReport = function (rptID) {
            return new Promise(function (resolve, reject) {
                delta.ajax.get(
                    '/ChatSession/ValidateReport?reportID=' + rptID,
                    function (rpt) {
                        resolve(rpt.isValid);
                    }
                );
            });
        },



        setupEditLinks = function () {
            _$wrapper.on('click', '.lnk-edit', function () {
                var prop = $(this).data('name');
                var rptListTitles = $('#ReportListTitles').val();
                var title = $(this).html();
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        `/ChatSession/Contexts?prop=${prop}&rptListTitles=${rptListTitles}`,
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                okButtonText: 'Save',
                                title: title,
                                css: 'modal-lg',
                                content: html,
                                afterOpen: function ($popup) {
                                    _popup_open = false;
                                    setupContextPopup($popup);
                                },

                                okCallback: function ($popup) {
                                    var $textarea = $popup.find('textarea');
                                    var chatContextID = $textarea.data('context-id');
                                    var value = $textarea.val().trim().replace(/(\r\n|\n|\r)/g, '<br>');
                                    $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    var formData = new FormData();
                                    var sessionName = $('#SessionName').val();
                                    assertString(sessionName, "chatOkCB: SessionName is not valid");

                                    formData.append("ID", chatContextID);
                                    formData.append("ContextField", prop);
                                    formData.append("Value", value);
                                    formData.append("SessionName", sessionName);

                                    // for the logging
                                    var field = prop.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
                                    var checked = $popup.find('input[type="checkbox"]:checked:not(:disabled)');

                                    if (value == '') {
                                        formData.append('LogIDs', `${field}_CLEAR`);
                                    }
                                    else if (checked.length > 0) {
                                        checked.each(function () {
                                            var logID = $(this).data('logging');
                                            formData.append('LogIDs', logID);
                                        });
                                    }
                                    else {
                                        formData.append('LogIDs', `${field}_CUSTOM`)
                                    }

                                    delta.ajax.postFormData(
                                        '/ChatSession/Contexts?sessionName=',
                                        formData,
                                        function (result) {
                                            var contextField = result.contextField;
                                            var value = result.value
                                            var $display = _$wrapper.find(`#${contextField}Display`);
                                            var $prompt = _$wrapper.find(`#${contextField}Prompt`);
                                            var $hdnCount = _$wrapper.find(`#hdn${contextField}`);

                                            if (result.value != null && result.value != '') {
                                                $prompt.hide();
                                                $display.html(value);
                                                $display.show();
                                                $hdnCount.val('True');
                                                // add system instructions
                                                if (contextField == "ContextRole") {
                                                    $('#systemRole').show();
                                                }
                                                if (contextField == "ContextTask") {
                                                    $('#systemTask').show();
                                                }
                                            }
                                            else {
                                                $display.html(value);
                                                $display.hide();
                                                $prompt.show();
                                                $hdnCount.val('False');
                                                if (contextField == "ContextRole") {
                                                    $('#systemRole').hide();
                                                }
                                                if (contextField == "ContextTask") {
                                                    $('#systemTask').hide();
                                                }
                                            }

                                            $(`#${contextField}`).val(result.value);
                                            updateContextCount(contextField);
                                            // update last updated time
                                            $('#lastUpdated').text(result.timestamp);
                                            delta.popup.close($popup);
                                        }
                                    );

                                    return false;
                                }
                            })
                        }
                    );
                    return false;
                }
            })
        },

        setupContextPopup = function ($popup) {
            var $textarea = $popup.find('textarea');
            //var $saveButton = $popup.find('.modal-footer button').first();

            // update report titles, where applicable
            var rptTitles = $('#ReportListTitles').val();
            $('#rptTitlesPopup').text(rptTitles);

            // fill in Org Details
            var header = $popup.find('.modal-title').text();
            if (header.includes('Organization Details')) {
                var orgDetails = $('#OrganizationDetails').val()
                    .replace(/<(?!br\s*\/?)[^>]+>/g, '')
                    .replace(/<br\s*\/?>/gi, '\n');
                $textarea.val(orgDetails);
            }


            // enable/disable save button, clear selections if textarea cleared
            var noText = $textarea.val().trim() === '';
            //$saveButton.prop('disabled', noText);
            $textarea.on('keyup', function () {
                noText = $(this).val().trim() === '';
                //saveButton.prop('disabled', noText);
                if (noText) {
                    $popup.find("input[type='checkbox']").prop('checked', false);
                    $textarea.trigger('blur');
                }
                setupCheckedCheckboxes($popup);
            });

            // single-prompt checkboxes - act as radios
            $(".single-prompt").on('click', function () {
                $popup.find(".single-prompt").not(this).prop('checked', false);
                if ($(this).is(':checked')) {
                    $textarea.trigger('focus');
                    var prompt = $('label[for="' + $(this).attr('id') + '"]').html();
                    var promptCleaned = prompt.replace(/<(?!br\s*\/?)[^>]+>/g, '');
                    var promptDisplay = promptCleaned.replace(/<br\s*\/?>/gi, '\n');
                    $textarea.val(promptDisplay);
                }
                else {
                    $textarea.val("");
                }
                $textarea.trigger('keyup');
            });

            // check saved options on popop open
            setupCheckedCheckboxes($popup);

            // multiple-prompt checkboxes - multiple checked
            $(".multiple-prompt").on('click', function () {
                var currentVal = $textarea.val().trim();
                var prompt = $('label[for="' + $(this).attr('id') + '"]').html();
                var promptCleaned = prompt.replace(/<(?!br\s*\/?)[^>]+>/g, '');
                var promptDisplay = promptCleaned.replace(/<br\s*\/?>/gi, '\n');
                if ($(this).is(':checked')) {
                    $textarea.trigger('focus');
                    $textarea.val(currentVal + (currentVal !== '' ? '\n---\n' : '') + promptDisplay);
                }
                else {
                    var newValue = currentVal.replace('---\n' + promptDisplay, '').replace(promptDisplay, '').replace('\n\n', '\n').trim();
                    if (newValue.startsWith('---\n')) {
                        newValue = newValue.substring(6); // remove the first 6 characters
                    } $textarea.val(newValue);
                }
                $textarea.trigger('keyup');
            });

        },


        setupCheckedCheckboxes = function ($popup) {
            var $textarea = $popup.find('textarea');
            var textVal = $textarea.val().replace(/\s/g, '');
            var $checkboxes = $popup.find('input[type="checkbox"]');
            $checkboxes.each(function () {
                var label = $('label[for="' + $(this).attr('id') + '"]').text().replace(/\s/g, '');
                $(this).prop('checked', textVal.includes(label));
            })
        },


        setupFormatPrompts = function () {
            _$wrapper.on('click', '#lnkFormatPrompts', function () {
                var prop = "ResponseFormat";
                var rptListTitles = $("#ReportListTitles").val();
                if (!_popup_open) {
                    _popup_open = true;
                    delta.ajax.get(
                        `/ChatSession/Contexts?prop=${prop}&rptListTitles=${rptListTitles}`,
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Format the Response',
                                css: 'modal-lg',
                                content: html,
                                okButtonText: 'Add to Message',
                                afterOpen: function ($popup) {
                                    _popup_open = false;
                                    setupFormatPopup($popup);
                                },
                                okCallback: function ($popup) {
                                    var isDisabled = $('#CurrentMessage').prop('disabled');
                                    if (!isDisabled) {

                                        // for logging
                                        var formData = new FormData();
                                        formData.append('ContextField', '');

                                        var sessionName = $("#SessionName").val();

                                        var value = $popup.find('textarea').val();
                                        var checked = $popup.find('.form-check-input:checked');
                                        if (checked.length > 0) {
                                            $popup.find('.form-check-input:checked').each(function () {
                                                var logID = $(this).data('logging');
                                                formData.append('LogIDs', logID);
                                            });
                                        }
                                        else if (value != '') {
                                            formData.append('LogIDs','FORMAT_CUSTOM');
                                        }
                                        
                                        var $textarea = $popup.find('textarea');
                                        var formatText = $textarea.val().trim();
                                        var $message = $('#CurrentMessage');
                                        var currentMessage = $message.val().trim();
                                        $message.val(currentMessage + (currentMessage !== '' ? '\n---\n' : 'Thanks! ') + formatText).trigger('input');

                                        // send logs
                                        delta.ajax.postFormData(`/ChatSession/Contexts?sessionName=${sessionName}`,
                                            formData,
                                            function () { }
                                        )
                                    }
                                }
                            })
                        }
                    )
                }
            })
        },


        setupFormatPopup = function ($popup) {
            var $textarea = $popup.find('textarea');
            var $saveButton = $popup.find('.modal-footer button').last();
            $saveButton.prop('disabled', true);
            $textarea.on('keyup', function () {
                var currValue = $(this).val();
                noText = currValue.trim() === '';
                $saveButton.prop('disabled', noText);
                if (noText) {
                    $popup.find("input[type='checkbox'], input[type='radio']").prop('checked', false);
                    $textarea.trigger('blur');
                }
                // update word count in prompt if changed in textarea
                else {
                    var pattern = /Limit the total output to (\d+) words\./;
                    var match = currValue.match(pattern);
                    if (match) {
                        var wordCount = parseInt(match[1], 10);
                        $('#wordCount').val(wordCount);
                    }
                }

                // remove any extraneous "---";
                let text = $textarea.val();
                text = text.replace(/^-+\n*/g, '');
                text = text.replace(/(\n-+\n)(-+\n)+/g, '$1');
                text = text.replace(/(\n?-+)+\n*$/g, '');
                $textarea.val(text);

                // check for patterns in textarea, remove selects if not found
                removeSelects($popup);

                


            });

            // Executive summary
            $("input[name='ExecSummary']").on('change', function () {
                var currTextVal = $textarea.val().trim();
                var promptVal = $(this).val();
                // clear any existing
                var patterns = [/(Include an Executive Summary at the (beginning|end)\.)/g, "Do not include an Executive Summary."];
                patterns.forEach(pattern => {
                    var currTextVal = $textarea.val().trim();
                    var newText = currTextVal.replace('---\n' + pattern, '').replace(pattern, '').replace('\n\n', '\n').trim();
                    $textarea.val(newText);
                })
                // update with new
                switch (promptVal) {
                    default:
                        $textarea.trigger('focus');
                        var currTextVal = $textarea.val().trim();
                        $textarea.val(currTextVal + (currTextVal !== '' ? '\n---\n' : '') + promptVal);
                        break;
                }
                $textarea.trigger('keyup');
            });

            // Bullet Points
            $("input[name='BulletPoints']").on('change', function () {
                var currTextVal = $textarea.val().trim();
                var promptVal = $(this).val();
                // clear any existing
                var patterns = ["Use bullet points.", "Do not use bullet points."]
                patterns.forEach(pattern => {
                    var currTextVal = $textarea.val().trim();
                    var newText = currTextVal.replace('---\n' + pattern, '').replace(pattern, '').replace('\n\n', '\n').trim();
                    $textarea.val(newText);
                })
                // update with new
                switch (promptVal) {
                    case (undefined):
                        break;
                    default:
                        $textarea.trigger('focus');
                        var currTextVal = $textarea.val().trim();
                        $textarea.val(currTextVal + (currTextVal !== '' ? '\n---\n' : '') + promptVal);
                        break;
                }
                $textarea.trigger('keyup');
            });

            // Rounding
            $("input[name='Rounding']").on('change', function () {
                var currTextVal = $textarea.val().trim();
                var promptVal = $(this).val();
                // clear any existing
                var patterns = ["Round amounts to nearest whole number.", "Round amounts to two decimals.", "Do not include amounts in the analysis."]
                patterns.forEach(pattern => {
                    var currTextVal = $textarea.val().trim();
                    var newText = currTextVal.replace('---\n' + pattern, '').replace(pattern, '').replace('\n\n', '\n').trim();
                    $textarea.val(newText);
                })
                // update with new
                switch (promptVal) {
                    default:
                        $textarea.trigger('focus');
                        var currTextVal = $textarea.val().trim();
                        $textarea.val(currTextVal + (currTextVal !== '' ? '\n---\n' : '') + promptVal);
                        break;
                }
                $textarea.trigger('keyup');
            });


            // update textarea when word count option checked
            $('#chkWordCount').on('click', function () {
                var wordCount = $('#wordCount').val();
                var currTextVal = $textarea.val().trim();
                var promptVal = `Limit the total output to ${wordCount} words.`;
                if ($(this).is(':checked')) {
                    $textarea.trigger('focus');
                    $textarea.val(currTextVal + (currTextVal !== '' ? '\n---\n' : '') + promptVal);
                }
                else {
                    var newValue = currTextVal.replace('---\n' + promptVal, '').replace(promptVal, '').replace('\n\n', '\n').trim();
                    $textarea.val(newValue);
                }
                $textarea.trigger('keyup');
            });


            // replace word count in textarea
            $("#wordCount").on("input", function () {
                var optionChecked = $('#chkWordCount').is(':checked');
                if (optionChecked) {
                    var currTextVal = $textarea.val().trim();
                    var newCount = $(this).val();

                    var pattern = /Limit the total output to (\d+) words\./;
                    var match = pattern.exec(currTextVal);

                    if (match) { // If the pattern is found
                        const newText = currTextVal.replace(pattern, `Limit the total output to ${newCount} words.`);
                        $textarea.val(newText);
                    }
                }
            });

        },


        // remove select if pattern not found in textarea
        removeSelects = function ($popup) {
            var $textarea = $popup.find('textarea');
            var textareaVal = $textarea.val();
            var patternExecSum = /(Include an Executive Summary at the (beginning|end)\.)/g;
            var patternBullets =  ["Use bullet points.", "Do not use bullet points."]
            var patternRound = ["Round amounts to nearest whole number.", "Round amounts to two decimals.", "Do not include amounts in the analysis."];
            var patternWords = /Limit the total output to (\d+) words\./;
            if (!patternExecSum.test(textareaVal)) {
                $('.execSumOption').prop('checked', false);
            }
            if (!patternWords.test(textareaVal)) {
                $('input[name="WordCount"]').prop('checked', false)
            }

            var patternFound = false;
            patternRound.forEach(function (pattern) {
                if (textareaVal.includes(pattern)) {
                    patternFound = true;
                }
            });
            if (!patternFound) {
                $('input[name="Rounding"]').prop('checked', false);
            }

            patternFound = false;
            patternBullets.forEach(function (pattern) {
                if (textareaVal.includes(pattern)) {
                    patternFound = true;
                }
            });
            if (!patternFound) {
                $('.bulletsOption').prop('checked', false);
            }

        }


    setupInitiateChatBtn = function () {
        _$wrapper.on('click', '#btnInitiateChat', function () {

            var { contextCompleted, sessionName } = getSetupData();

            assertString(sessionName, "InitChat: Session Name is not valid");

            if (!contextCompleted) {
                var initialMessage = "Please select an <span class='bold'>Analysis Role</span> and an <span class='bold'>Analysis Task</span> to chat.";
                var goToDivID = "#collapseContextConfiguration";
                $(this).prop('disabled', false);
                showWarningPopup(initialMessage, goToDivID);
            }
            else {

                var initialMessage = '';

                var orgDetails = $('#OrganizationDetailsDisplay').text().trim();
                if (orgDetails && orgDetails!== '') {
                    initialMessage += orgDetails;
                }

                var currentUrgentInfo = $('#CurrentUrgentInfoDisplay').text().trim(); 
                if (currentUrgentInfo) { 
                    if (initialMessage) {
                        initialMessage += '<br /><div>---</div><br />'; 
                    }
                    initialMessage += currentUrgentInfo; 
                }


                var reportListTitles = $('#ReportListTitles').val();
                if (reportListTitles) {
                    if (initialMessage) {
                        initialMessage += '<br /><div>---</div><br />'; 
                    }
                    initialMessage += `Review the attached ${reportListTitles}`;
                }

                var roundAmounts = $('#RoundAmountsToNearestWholeNumber').val();
                if (roundAmounts) {
                    if (initialMessage) {
                        initialMessage += '<br /><div>---</div><br />';
                    }
                    initialMessage += roundAmounts;
                }

                var contextTask = $('#ContextTaskDisplay').text().trim();
                if (contextTask) {
                    if (initialMessage) {
                        initialMessage += '<br /><div>---</div><br />'; 
                    }
                    initialMessage += contextTask;
                }

                var ContextAudience = $('#ContextAudienceDisplay').text().trim();
                if (ContextAudience) {
                    if (initialMessage) {
                        initialMessage += '<br /><div>---</div><br />';
                    }
                    initialMessage += ContextAudience;
                }

                var currentMessage = initialMessage;
                var messageCleaned = currentMessage.replace(/<(?!br\s*\/?)[^>]+>/g, '');
                initialMessage = messageCleaned.replace(/<br\s*\/?>/gi, '\n').trim();

                // Continue with the chat initiation process
                $('#ResponseCount').val(1);
                $('#CurrentMessage').val(initialMessage);
                $('#CurrentMessage').prop('disabled', true);
                $('#btnSendMessage').prop('disabled', false);
                $('#btnSendMessage').html('<i class="fa-regular fa-spinner fa-spin fs-6"></i>');
                $('#btnSendMessage').trigger('click');
                $('#prompts').hide();
                $('#chat-wait').show();

                // Automatically switch to chat section
                $('#btnChatDiv').trigger('click');
                $('#ResponseCount').val(0);
               
            }
        });
    },



        setupChatPrompts = function () {
            _$wrapper.on('click', '#lnkChatPrompts', function () {
                if (!_popup_open) {
                    _popup_open = true;
                    var prop = "FollowupPrompt";
                    var rptListTitles = $("#ReportListTitles").val();

                    delta.ajax.get(
                        `/ChatSession/Contexts?prop=${prop}&rptListTitles=${rptListTitles}`,

                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Follow-up Prompt Ideas',
                                css: 'modal-lg',
                                content: html,
                                okButtonText: 'Add to Message',
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {
                                    var isDisabled = $('#CurrentMessage').prop('disabled');

                                    if (!isDisabled) {
                                        // for logging
                                        var formData = new FormData();
                                        formData.append('ContextField', '');
                                        $popup.find($('input[type="checkbox"].prompt:checked')).each(function () {
                                            // Get the associated label text
                                            var prompt = $('label[for="' + $(this).attr('id') + '"]').text();
                                            var logID = $(this).data('logging');
                                            formData.append('LogIDs', logID);
                                            $('#CurrentMessage').val(function (_, currentValue) {
                                                return currentValue + (currentValue !== '' ? '\n---\n' : 'Thanks! ') + prompt;
                                            });

                                            $('#CurrentMessage').trigger('input');
                                        });

                                        // send logIDs for logging
                                        delta.ajax.postFormData(
                                            '/ChatSession/Contexts?sessionName=',
                                            formData,
                                            function () { }
                                        )

                                    }

                                }
                            });
                        }
                    )
                }
            })
        },


        setupSendMessageBtn = function () {
            $("#CurrentMessage").on("input", function () {
                var text = $(this).val().trim(); // Get the trimmed value of the textarea

                // If the textarea is empty or only contains spaces, disable the button, otherwise enable it
                if (text === "") {
                    $("#btnSendMessage").prop("disabled", true);
                } else {
                    $("#btnSendMessage").prop("disabled", false);
                }
            });
        },


        setupSendMessage = function () {
            _$wrapper.on('click', '#btnSendMessage', function () {


                // validate Session name
                var sessionName = $('#SessionName').val();
                if (sessionName == '') {
                    // scroll to top to show error message
                    var $contentInner = $(".content-inner");
                    $contentInner.scrollTop(0);
                    $('#sessionNameInvalid').show();
                    return false;
                }
                else {
                    $('#sessionNameInvalid').hide();
                }

                // validate at least one report selected
                if ($('#ReportCount').val() == 0) {
                    $('#collapseData').collapse('show');
                    $('#errNoReports').show();
                    return false;
                }
                else {
                    $('#errNoReports').hide();
                    $('#collapseData').collapse('hide');
                }

                // validate at least one instruction or additional prompt
                if ($('.chat-instruction:checked').length == 0 && $('#CurrentMessage').val().trim() === '') {
                    $('#errNoPrompts').show();
                    return false;
                } else {
                    $('#errNoPrompts').hide();
                }

                $('#btnSendMessage').html('<i class="fa-regular fa-spinner fa-spin fs-6"></i>');
                $("#btnSendMessage").prop('disabled', true);
                $("#CurrentMessage").prop('disabled', true);

                var formData = new FormData();
                var _$form = _$wrapper.find('form');
                _$form.find('input:not(:radio), select, textarea').each(function () {
                    var $elem = $(this);
                    formData.append($elem.attr('name'), $elem.val());
                })

                // get the instruction id
                var checkedRadio = $('.chat-instruction:radio:checked');
                if (checkedRadio.length > 0) {
                    var instructionID = checkedRadio.data('instructionid');
                    formData.append('CurrentInstructionID', instructionID);
                }

                $('#chat-wait').show();
                $('#prompts').hide();
                // the session name must be included when calling save or we get undefined. MJC
                formData.append("SessionName", sessionName);

                delta.ajax.postFormData(
                    '/ChatSession/Save',
                    formData,
                    function (result) {
                        // save the response
                        _current_response_id = result.chatResponseID;

                        //start the time
                        startChatResponseTimer();
                    }
                );
            })
        },


        setupCopyResponse = function () {
            // Bind the event handler to existing buttons
            _$wrapper.find('.copy-response').off('click').on('click', function () {
                handleCopyButtonClick($(this));
            });
        },

        // Function to handle the copy button click
        handleCopyButtonClick = async function ($button) {

            var $prevParagraph = $button.closest('.row').find('.response div');

            // using Clipboard API
            var innerHTML = $prevParagraph.html();
            var fontFamily = $prevParagraph.css('font-family');
            var contentToCopy = `
                    <style>
                        .copied-content {
                            font-family: ${fontFamily};
                        }
                    </style>
                    <div class="copied-content">
                        ${innerHTML}
                    </div>
                `;

            const blob = new Blob([contentToCopy], { type: 'text/html' });
            const clipboardItem = new ClipboardItem({ 'text/html': blob });
            navigator.clipboard.write([clipboardItem]);

            // Fire tooltip to show copied, then remove
            $prevParagraph.attr('title', 'Response copied!');
            $prevParagraph.tooltip('show');
            setTimeout(function () {
                $prevParagraph.tooltip('dispose');
                $prevParagraph.removeAttr('title');
            }, 1000);
        },


        // scrolls to bottom of chat when chat accordion is opened
        setupChatScroll = function () {
            var $chatDiv = _$wrapper.find('#collapseChat');
            $chatDiv.on('shown.bs.collapse', function () {
                chatScrollToBottom();
            });
        },


        // scroll to bottom of chat
        chatScrollToBottom = function () {
            var $contentInner = $(".content-inner");
            var scrollHeight = $contentInner.prop("scrollHeight");
            $contentInner.animate({ scrollTop: scrollHeight }, 1000); // Adjust the duration (1000ms = 1 second)
        },


        //
        // start the report timer polling
        //
        startReportTimer = function () {
            setTimeout(
                function () {
                    delta.ajax.get(
                        'ChatSession/ReportPoll?chatID=' + _$wrapper.find('#ID').val(),
                        function (result) {
                            $('#reports-list').html(result.html);
                            showHideSelectReports();
                            if (result.loadingQBOReportData) {
                                startReportTimer();
                            }
                        }
                    );
                },
                5000
            );
        },


        //
        // start the chat response timer
        //
        startChatResponseTimer = function () {
            setTimeout(
                function () {
                    delta.ajax.get(
                        'ChatSession/ChatResponsePoll?chatID=' + _$wrapper.find('#ID').val() + '&chatResponseID=' + _current_response_id,
                        function (result) {
                            if (!result.done) {
                                startChatResponseTimer();
                            } else {
                                // update UI
                                var date = result.chat.analysisEndDate;
                                var updatedDate = `${date.substring(5, 7)}/${date.substring(8, 10)}/${date.substring(0, 4)}`
                                $('#SessionName').val(result.chat.sessionName)
                                $('#AnalysisEndDate').val(updatedDate);
                                $('#AnalysisEndDate').prop('disabled', true);

                                // chat response div
                                if (result.chat.currentMessage == null) {
                                    result.chat.currentMessage = "<span class=italic>(No additional prompt entered.)</span>";
                                }
                                var _$responseDiv = $('#chat-responses');
                                var responseHtml = marked.parse(result.chat.currentResponse);

                                var date = result.timestamp.date;
                                var time = result.timestamp.time;

                                var template = `
                                    <div class="row justify-content-center">
                                        <div class="col-10">
                                            <p class="border rounded py-2 px-2" style="background-color:#eaecef; white-space:pre-line">${result.chat.currentMessage}</p>
                                        </div>
                                        <div class="col-1"></div>
                                    </div>

                                    <div class="row justify-content-center">
                                        <div class="col-10 response pl35">
                                            <div class="border rounded p-2 mb-3">${responseHtml}</div>
                                        </div>
                                        <div class="col-1">
                                            <div class="muted">${date}<br />${time}</div>
                                            <button title="Copy" type="button" class="btn btn-link px-0 ml-0 copy-response" style="color:darkslategray"><i class="fa-solid fa-copy"></i></button>
                                        </div>
                                    </div>
                                `;

                                _$responseDiv.append(template);

                                setupCopyResponse();

                                //hide add reports add
                                $('.lnkReports').hide();
                                // remove trash icons from report badges
                                $('span').has('a.delete-report').remove();
                                // remove context edit links
                                //$('.lnk-edit').hide();
                                $('.div-edit').hide();
                                $('.div-no-edit').show();
                                $('#btnInitiateChat').hide();

                                // update the response count
                                updateResponseCount();

                                // update last updated time
                                $('#lastUpdated').text(`${date} ${time}`)

                                // clear/scroll to new message
                                $('#chat-wait').hide();
                                $('#prompts').show();
                                $("#btnSendMessage").prop('disabled', true);
                                $('#CurrentMessage').prop('disabled', false);
                                $('#CurrentMessage').val('');
                                $('#btnSendMessage').html('<i class="fa-light fa-paper-plane-top"></i>');
                                chatScrollToBottom();

                            }
                        }
                    );
                },
                5000
            );
        },


        setupViewReports = function () {
            _$wrapper.on('click', '.view-report', function () {
                var reportID = $(this).data('report-id');

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/ChatSession/ViewReport?reportID=' + reportID,

                        function (html) {
                            delta.popup.open({
                                type: 'alert',
                                title: 'Report Content',
                                css: 'modal-lg',
                                content: html,
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                            });
                        }
                    )
                }
            })
        },

        setupDeleteReports = function () {
            _$wrapper.on('click', '.delete-report', function () {
                var $badge = $(this).closest('.badge');
                var chatReportID = $(this).data('report-id');
                var reportTitle = $(this).data('report-title');

                if (!_popup_open) {
                    _popup_open = true;

                    delta.popup.open({
                        type: 'confirm',
                        okButtonText: 'Delete',
                        title: 'Delete Report',
                        content: `Are you sure you want to delete the report <span class="bold">${reportTitle}</span>?`,
                        afterOpen: function () {
                            _popup_open = false;
                        },
                        okCallback: function ($popup) {
                            $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                            delta.ajax.get(
                                '/ChatSession/DeleteReport?chatReportID=' + chatReportID,
                                function (result) {
                                    delta.popup.close($popup);
                                    $badge.remove();
                                    updateReportCount(-1);
                                    $('#lastUpdated').text(result.timestamp);
                                    $('#ReportListTitles').val(result.titles);
                                    $('#rptListTitles').text(result.titles);
                                }
                            );

                            return false;
                        }
                    });
                }
            });

        },

        setupExcelCopy = function () {
            _$wrapper.on('click', '#load-report', function () {
                initiateExcelCopy();
            })
        },


        initiateExcelCopy = function (rptTitle = null, rptDate = null) {
            if (!_popup_open) {
                _popup_open = true;
                // if params are null, we are rendering the empty popup
                // if params have value, we are returning to copy popup from review screen
                var url = '/ChatSession/ExcelCopy';
                var formData = new FormData();
                // return to copy popup with previous data
                if (rptTitle != null) {
                    formData.append('ReportTitle', rptTitle);
                    formData.append('ReportPeriodEndDate', rptDate);
                    url += '?isReturn=true';
                }
                delta.ajax.postFormData(
                    url,
                    formData,
                    function (result) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Copy Report from Excel',
                            css: 'modal-lg',
                            content: rptTitle == null ? result : result.html,
                            okButtonText: 'Continue',
                            afterOpen: function ($popup) {
                                _popup_open = false;
                                delta.utility.setupDatePicker($popup);
                            },
                            okCallback: function ($popup) {

                                $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                var formData = new FormData();
                                var _$form = $popup.find('form');
                                _$form.find('input, textarea').each(function () {
                                    var $elem = $(this);
                                    formData.append($elem.attr('name'), $elem.val());
                                });

                                delta.ajax.postFormData(
                                    '/ChatSession/ExcelCopy',
                                    formData,
                                    function (result) {
                                        if (result.isValid) {
                                            delta.popup.close($popup);
                                            delta.popup.open({
                                                type: 'generic',
                                                title: 'Review Report',
                                                css: 'modal-lg',
                                                content: result.html,
                                                buttons: [
                                                    {
                                                        isPrimary: true,
                                                        isOk: false,
                                                        isCancel: false,
                                                        text: 'Back',
                                                        callback: function ($popup) {
                                                            var rptTitle = $popup.find('#ReportTitle').val();
                                                            var rptDate = $popup.find('#ReportPeriodEndDate').val();
                                                            initiateExcelCopy(rptTitle, rptDate);
                                                            delta.popup.close($popup)
                                                        }
                                                    },
                                                    {
                                                        isOk: true,
                                                        isPrimary: true,
                                                        text: 'Save',
                                                    },
                                                    {
                                                        isCancel: true,
                                                        text: 'Cancel'
                                                    }
                                                ],
                                                afterOpen: function ($popup) {
                                                    _popup_open = false;
                                                    delta.utility.setupDatePicker($popup);
                                                },
                                                okCallback: function ($popup) {

                                                    $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                                    var formData = new FormData();
                                                    var _$form = $popup.find('form');
                                                    _$form.find('input, textarea').each(function () {
                                                        var $elem = $(this);
                                                        formData.append($elem.attr('name'), $elem.val());
                                                    });
                                                    // saved in case user does exits session before chatting
                                                    var sessionName = _$wrapper.find('#SessionName').val();


                                                    delta.ajax.postFormData(
                                                        '/ChatSession/ExcelSave?sessionName=' + encodeURIComponent(sessionName),
                                                        formData,
                                                        function (result) {
                                                            if (result.isValid) {
                                                                $('#reports-list').html(result.reportListHtml);
                                                                $('#ReportSource').prop('disabled', true);
                                                                $('#lastUpdated').text(result.timestamp);
                                                                updateReportCount(1);
                                                                $('#ReportListTitles').val(result.titles);
                                                                $('#rptListTitles').text(result.titles);
                                                                delta.popup.close($popup);
                                                            }
                                                            else {
                                                                $popup.find('.modal-footer .fa-spinner').remove();
                                                                $popup.find('.modal-body').html(result.popupHtml);
                                                                delta.popup.enableButtons($popup);
                                                            }
                                                        }
                                                    );
                                                    return false;
                                                }
                                            })
                                        }
                                        else {
                                            $popup.find('.modal-footer .fa-spinner').remove();
                                            $popup.find('.modal-body').html(result.html);
                                            delta.popup.enableButtons($popup);
                                        }
                                    }
                                );

                                return false;
                            }
                        });
                    }
                )
            }
        },


        updateReportCount = function (count, isFinal = false) {
            // update count
            var $rptCount = $('#ReportCount');
            var currCount = parseInt($rptCount.val());
            var newCount = isFinal ? count : currCount + count;
            // update UI
            $rptCount.val(newCount);
            var btnText = `(${newCount} report${newCount != 1 ? "s" : ""})`;
            $('#btnReportCount').text(btnText);
            if (newCount == 0) {
                $('#ReportSource').prop('disabled', false);
                $('#AnalysisEndDate').prop('disabled', false);
            }
        },

        updateResponseCount = function () {
            // update count
            var $respCount = $('#ResponseCount');
            var currCount = parseInt($respCount.val());
            var newCount = currCount + 1;
            // update UI
            $respCount.val(newCount);
            var btnText = `(${newCount} response${newCount != 1 ? "s" : ""})`;
            $('#btnResponseCount').text(btnText);
        },

        updateContextCount = function (contextField) {
            var { orgDetailsCount, contextCompletedCount } = getSetupData();
            if (contextField == "OrganizationDetails") {
                $('#btnOrgDetailsCount').text(`${orgDetailsCount}/1 completed`);
            }
            else {
                $('#btnContextCount').text(`(${contextCompletedCount}/4 completed)`)
            }
        }

    function assertString(value, message = "String must be valid") {
       
        //if (process.env.NODE_ENV === 'development') {
        //    // Debug mode
        //    if (typeof value !== 'string' || !value) {
        //        throw new Error(message);
        //    }
        //} else {
        //    // Production code
        //}
      
    }
    dummy = function () { };

    $(document).ready(init);
})();

